export default "<div ng-show=\"commandEnabled\">\r\n    When Set Position is selected, click anywhere in the map to set a fixed position tag there.\r\n</div>";